import { contrastChart } from '@iq/react-components';

export const colorOptions = [
  { value: contrastChart[0], id: 'contrast-color-1', label: 'Blue' },
  { value: contrastChart[1], id: 'contrast-color-2', label: 'Orange' },
  { value: contrastChart[2], id: 'contrast-color-3', label: 'Green' },
  { value: contrastChart[3], id: 'contrast-color-4', label: 'Red' },
  { value: contrastChart[4], id: 'contrast-color-5', label: 'Purple' },
  { value: contrastChart[5], id: 'contrast-color-6', label: 'Grey' },
  { value: contrastChart[6], id: 'contrast-color-7', label: 'Gold' },
  { value: contrastChart[7], id: 'contrast-color-8', label: 'Magenta' },
  { value: contrastChart[8], id: 'contrast-color-9', label: 'Teal' },
  { value: contrastChart[9], id: 'contrast-color-10', label: 'Light Blue' },
];

export const resolveColor = (color) =>
  colorOptions.find((option) => option.id === color)?.value ?? color;

export const resolveColorId = (color) =>
  colorOptions.find(
    (option) =>
      option.id === color || String(option.value).toLowerCase() === String(color).toLowerCase()
  )?.id ?? color;

const lightenDarkenColor = (col, amt) => {
  let usePound = false;
  let color = col;

  if (color[0] === '#') {
    color = color.slice(1);
    usePound = true;
  }

  if (color.length === 3) {
    color = `${color[0].repeat(2)}${color[1].repeat(2)}${color[2].repeat(2)}`;
  }

  const num = Number.parseInt(color, 16);

  let r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if (r < 0) r = 0;

  let b = ((num >> 8) & 0x00_ff) + amt;

  if (b > 255) b = 255;
  else if (b < 0) b = 0;

  let g = (num & 0x00_00_ff) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16);
};

export default colorOptions;
export { lightenDarkenColor };
